<editor
	#subjectEditor
	[formControl]="control"
	[init]="{ 
		height: 103,
		width: '100%',
		menubar: 'placeholders',
		menu: {
			placeholders: {
				title: 'Placeholders', 
				items: placeholdersMenuItems 
			}
		},
		statusbar: false,
		toolbar: 'placeholders',
		setup: subjectEditorSetup,
		paste_block_drop: true,
		paste_as_text: true,
		promotion: false,
		license_key: tinyMceKey,
		ui_mode: 'split',
		placeholder: placeholderText,
		iframe_aria_text: placeholderText,
		content_style: editorStyle
	}"
></editor>
<mat-error class="error" aria-live="polite">{{ control.errors?.msError }}</mat-error>